import { Box, Link, ListItem, ListItemText, Typography } from "@mui/material";
import { Link as RouterLink } from "react-router-dom";
import {
  CompanyLifecycleEvent,
  CompanyLifecycleEventTypeValues,
} from "models/CompanyLifecycleEvent";
import CompanyStateChip from "pages/companies/components/CompanyStateChip";
import { formatDateTime } from "utilities/formatDateTime";

type LogItemProps = { event: CompanyLifecycleEvent };

const LogItem: React.FC<LogItemProps> = (props) => {
  const { event } = props;

  return (
    <ListItem divider>
      <ListItemText
        primary={
          <Box display="flex" alignItems="center" gap={0.5}>
            <Link component={RouterLink} to={`/users/view/${event.actor.id}`}>
              {event.actor.userName}
            </Link>

            <Typography component="span" textTransform="lowercase">
              {CompanyLifecycleEventTypeValues[event.eventType]}:
            </Typography>

            <CompanyStateChip state={event.fromState} />

            {event.fromState !== event.toState && (
              <>
                →
                <CompanyStateChip state={event.toState} />
              </>
            )}

            <Typography fontSize="small" ml="auto">
              {formatDateTime(event.createdAt)}
            </Typography>
          </Box>
        }
        secondary={
          event.reason && (
            <Typography
              component="pre"
              sx={{
                whiteSpace: "break-spaces",
                overflowWrap: "anywhere",
                width: "fit-content",
                mt: 1,
              }}
            >
              {event.reason}
            </Typography>
          )
        }
      />
    </ListItem>
  );
};

export default LogItem;
